export default {"src":"/_next/static/media/exercise.190eaea0.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};